"use strict";
// TODO Need to go through this file to learn what should be thrown away vs kept
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookie = exports.trackIdentifyUser = exports.sendMarketingProperties = exports.trackEvent = exports.coalesceListToProductId = exports.coalesceToProductId = exports.getPageContext = void 0;
const zolaWindow = typeof window !== "undefined" ? window : {};
function getPageContext() {
    var _a;
    return {
        path: zolaWindow.location.pathname,
        search: zolaWindow.location.search,
        referrer: ((_a = zolaWindow === null || zolaWindow === void 0 ? void 0 : zolaWindow.zola) === null || _a === void 0 ? void 0 : _a.referrer) || document.referrer,
        url: zolaWindow.location.href,
        title: document.title,
    };
}
exports.getPageContext = getPageContext;
/**
 * Sets the product_id to the first key in keysToCoalesce that is in the payload.
 *
 * We enforce that the event payload cannot contain multiple different keys when defining the events
 */
function coalesceToProductId(payload, keysToCoalesce) {
    const finalPayload = payload || {};
    for (const key in keysToCoalesce) {
        if (key in payload) {
            finalPayload.product_id = payload[key];
            break;
        }
    }
    return finalPayload;
}
exports.coalesceToProductId = coalesceToProductId;
/**
 * Sets the product_id to the first key in keysToCoalesce for all entities in the 'product' property
 * of the event payload
 *
 * We enforce that the event payload cannot contain multiple different keys when defining the events
 */
function coalesceListToProductId(payload, keysToCoalesce) {
    let products = [];
    for (const product of payload.products || []) {
        products.push(coalesceToProductId(product, keysToCoalesce));
    }
    payload.products = products;
    return payload;
}
exports.coalesceListToProductId = coalesceListToProductId;
function trackEvent(eventName, payload, options = {}) {
    var _a;
    const optionsFinal = options || {};
    optionsFinal.page = getPageContext();
    if ((_a = zolaWindow === null || zolaWindow === void 0 ? void 0 : zolaWindow.analytics) === null || _a === void 0 ? void 0 : _a.track) {
        zolaWindow.analytics.track(eventName, payload, optionsFinal);
    }
}
exports.trackEvent = trackEvent;
function sendMarketingProperties(marketingProperties) {
    zolaWindow.dataLayer = zolaWindow.dataLayer || [];
    zolaWindow.dataLayer.push(marketingProperties);
}
exports.sendMarketingProperties = sendMarketingProperties;
function trackIdentifyUser(userId, traits, options) {
    var _a;
    const optionsFinal = options || {};
    optionsFinal.page = getPageContext();
    if ((_a = zolaWindow === null || zolaWindow === void 0 ? void 0 : zolaWindow.analytics) === null || _a === void 0 ? void 0 : _a.analytics) {
        zolaWindow.analytics.identify(userId, traits, optionsFinal);
    }
}
exports.trackIdentifyUser = trackIdentifyUser;
/**
 * get a cookie
 */
function getCookie(key) {
    const name = `${key}=`;
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i += 1) {
        let c = ca[i];
        while (c.charAt(0) === " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
exports.getCookie = getCookie;
